/* tslint:disable */
/* eslint-disable */
/**
 * Ptw100 API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues, typeFirst } from '../runtime';
import type { ReferencingObjectDto } from './ReferencingObjectDto';
import {
    ReferencingObjectDtoFromJSON,
    ReferencingObjectDtoFromJSONTyped,
    ReferencingObjectDtoToJSON,
} from './ReferencingObjectDto';
import type { TaskInJobDto } from './TaskInJobDto';
import {
    TaskInJobDtoFromJSON,
    TaskInJobDtoFromJSONTyped,
    TaskInJobDtoToJSON,
} from './TaskInJobDto';
import type { UserCatalogDto } from './UserCatalogDto';
import {
    UserCatalogDtoFromJSON,
    UserCatalogDtoFromJSONTyped,
    UserCatalogDtoToJSON,
} from './UserCatalogDto';
import type { ProtocolDto } from './ProtocolDto';
import {
    ProtocolDtoFromJSON,
    ProtocolDtoFromJSONTyped,
    ProtocolDtoToJSON,
} from './ProtocolDto';
import type { RoleCatalogDto } from './RoleCatalogDto';
import {
    RoleCatalogDtoFromJSON,
    RoleCatalogDtoFromJSONTyped,
    RoleCatalogDtoToJSON,
} from './RoleCatalogDto';
import type { PossibleActionDto } from './PossibleActionDto';
import {
    PossibleActionDtoFromJSON,
    PossibleActionDtoFromJSONTyped,
    PossibleActionDtoToJSON,
} from './PossibleActionDto';
import type { StateOfUse } from './StateOfUse';
import {
    StateOfUseFromJSON,
    StateOfUseFromJSONTyped,
    StateOfUseToJSON,
} from './StateOfUse';
import type { FileMetaInfoDto } from './FileMetaInfoDto';
import {
    FileMetaInfoDtoFromJSON,
    FileMetaInfoDtoFromJSONTyped,
    FileMetaInfoDtoToJSON,
} from './FileMetaInfoDto';
import type { EntityOrigin } from './EntityOrigin';
import {
    EntityOriginFromJSON,
    EntityOriginFromJSONTyped,
    EntityOriginToJSON,
} from './EntityOrigin';
import type { JobConfigurationDtoTargetSystem } from './JobConfigurationDtoTargetSystem';
import {
    JobConfigurationDtoTargetSystemFromJSON,
    JobConfigurationDtoTargetSystemFromJSONTyped,
    JobConfigurationDtoTargetSystemToJSON,
} from './JobConfigurationDtoTargetSystem';
import type { PtwCommentDto } from './PtwCommentDto';
import {
    PtwCommentDtoFromJSON,
    PtwCommentDtoFromJSONTyped,
    PtwCommentDtoToJSON,
} from './PtwCommentDto';
import type { JobScheduleDto } from './JobScheduleDto';
import {
    JobScheduleDtoFromJSON,
    JobScheduleDtoFromJSONTyped,
    JobScheduleDtoToJSON,
} from './JobScheduleDto';

/**
 * 
 * @export
 * @interface JobConfigurationDto
 */
export interface JobConfigurationDto {
    /**
     * 
     * @type {string}
     * @memberof JobConfigurationDto
     */
    id: string;
    /**
     * 
     * @type {string}
     * @memberof JobConfigurationDto
     */
    readonly creationTime?: string;
    /**
     * 
     * @type {number}
     * @memberof JobConfigurationDto
     */
    readonly creatorUserId?: number | null;
    /**
     * 
     * @type {string}
     * @memberof JobConfigurationDto
     */
    lastModificationTime?: string | null;
    /**
     * 
     * @type {number}
     * @memberof JobConfigurationDto
     */
    readonly lastModifierUserId?: number | null;
    /**
     * 
     * @type {number}
     * @memberof JobConfigurationDto
     */
    commentCount?: number | null;
    /**
     * 
     * @type {number}
     * @memberof JobConfigurationDto
     */
    commentAttachmentsCount?: number | null;
    /**
     * 
     * @type {string}
     * @memberof JobConfigurationDto
     */
    lastComment?: string | null;
    /**
     * 
     * @type {boolean}
     * @memberof JobConfigurationDto
     */
    isAvailable?: boolean;
    /**
     * 
     * @type {EntityOrigin}
     * @memberof JobConfigurationDto
     */
    origin?: EntityOrigin;
    /**
     * 
     * @type {Array<PossibleActionDto>}
     * @memberof JobConfigurationDto
     */
    readonly possibleActions?: Array<PossibleActionDto> | null;
    /**
     * 
     * @type {UserCatalogDto}
     * @memberof JobConfigurationDto
     */
    creatorUser?: UserCatalogDto;
    /**
     * 
     * @type {UserCatalogDto}
     * @memberof JobConfigurationDto
     */
    lastModifierUser?: UserCatalogDto;
    /**
     * 
     * @type {UserCatalogDto}
     * @memberof JobConfigurationDto
     */
    editingUser?: UserCatalogDto;
    /**
     * 
     * @type {string}
     * @memberof JobConfigurationDto
     */
    editingTime?: string | null;
    /**
     * 
     * @type {Array<PtwCommentDto>}
     * @memberof JobConfigurationDto
     */
    comments?: Array<PtwCommentDto> | null;
    /**
     * 
     * @type {Array<FileMetaInfoDto>}
     * @memberof JobConfigurationDto
     */
    attachments?: Array<FileMetaInfoDto> | null;
    /**
     * 
     * @type {boolean}
     * @memberof JobConfigurationDto
     */
    isReferenced?: boolean;
    /**
     * 
     * @type {Array<ReferencingObjectDto>}
     * @memberof JobConfigurationDto
     */
    isReferencedBy?: Array<ReferencingObjectDto> | null;
    /**
     * 
     * @type {StateOfUse}
     * @memberof JobConfigurationDto
     */
    state?: StateOfUse;
    /**
     * 
     * @type {string}
     * @memberof JobConfigurationDto
     */
    name: string;
    /**
     * 
     * @type {string}
     * @memberof JobConfigurationDto
     */
    iuid?: string | null;
    /**
     * 
     * @type {string}
     * @memberof JobConfigurationDto
     */
    description?: string | null;
    /**
     * 
     * @type {Array<ProtocolDto>}
     * @memberof JobConfigurationDto
     */
    protocols?: Array<ProtocolDto> | null;
    /**
     * 
     * @type {Array<number>}
     * @memberof JobConfigurationDto
     */
    assignedUserIds?: Array<number> | null;
    /**
     * 
     * @type {Array<number>}
     * @memberof JobConfigurationDto
     */
    assignedRoleIds?: Array<number> | null;
    /**
     * 
     * @type {Array<UserCatalogDto>}
     * @memberof JobConfigurationDto
     */
    assignedUsers?: Array<UserCatalogDto> | null;
    /**
     * 
     * @type {Array<RoleCatalogDto>}
     * @memberof JobConfigurationDto
     */
    assignedRoles?: Array<RoleCatalogDto> | null;
    /**
     * 
     * @type {Array<string>}
     * @memberof JobConfigurationDto
     */
    assignedRolesDisplayNames?: Array<string> | null;
    /**
     * 
     * @type {boolean}
     * @memberof JobConfigurationDto
     */
    reviewRequired?: boolean;
    /**
     * 
     * @type {Array<number>}
     * @memberof JobConfigurationDto
     */
    reviewUserIds?: Array<number> | null;
    /**
     * 
     * @type {Array<number>}
     * @memberof JobConfigurationDto
     */
    reviewRoleIds?: Array<number> | null;
    /**
     * 
     * @type {Array<UserCatalogDto>}
     * @memberof JobConfigurationDto
     */
    reviewUsers?: Array<UserCatalogDto> | null;
    /**
     * 
     * @type {Array<RoleCatalogDto>}
     * @memberof JobConfigurationDto
     */
    reviewRoles?: Array<RoleCatalogDto> | null;
    /**
     * 
     * @type {Array<string>}
     * @memberof JobConfigurationDto
     */
    reviewRolesDisplayNames?: Array<string> | null;
    /**
     * 
     * @type {boolean}
     * @memberof JobConfigurationDto
     */
    autoApprove?: boolean;
    /**
     * 
     * @type {string}
     * @memberof JobConfigurationDto
     */
    targetSystemId?: string | null;
    /**
     * 
     * @type {JobConfigurationDtoTargetSystem}
     * @memberof JobConfigurationDto
     */
    targetSystem?: JobConfigurationDtoTargetSystem | null;
    /**
     * 
     * @type {Array<TaskInJobDto>}
     * @memberof JobConfigurationDto
     */
    tasks?: Array<TaskInJobDto> | null;
    /**
     * 
     * @type {number}
     * @memberof JobConfigurationDto
     */
    activeTaskInJobCount?: number;
    /**
     * 
     * @type {JobScheduleDto}
     * @memberof JobConfigurationDto
     */
    schedule?: JobScheduleDto;
    /**
     * 
     * @type {string}
     * @memberof JobConfigurationDto
     */
    $type?: JobConfigurationDtoTypeEnum;
}


/**
 * @export
 */
export const JobConfigurationDtoTypeEnum = {
    PtwPtw100AppZeroApplicationSharedJobConfigurationComponentDtoJobConfigurationDtoPtwPtw100AppZeroApplicationShared: 'Ptw.Ptw100.AppZero.Application.Shared.JobConfigurationComponent.Dto.JobConfigurationDto, Ptw.Ptw100.AppZero.Application.Shared'
} as const;
export type JobConfigurationDtoTypeEnum = typeof JobConfigurationDtoTypeEnum[keyof typeof JobConfigurationDtoTypeEnum];



/**
 * Check if a given object implements the JobConfigurationDto interface.
 */
export function instanceOfJobConfigurationDto(value?: unknown): value is JobConfigurationDto {
    return !!value && typeof value === 'object' && "$type" in value && value.$type === Object.values(JobConfigurationDtoTypeEnum)[0];
}

export function JobConfigurationDtoFromJSON(json: any): JobConfigurationDto {
    return JobConfigurationDtoFromJSONTyped(json, false);
}

export function JobConfigurationDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): JobConfigurationDto {
    if (json == null) {
        return json;
    }
    return {
        
        'id': json['id'],
        'creationTime': json['creationTime'] == null ? undefined : json['creationTime'],
        'creatorUserId': json['creatorUserId'] == null ? undefined : json['creatorUserId'],
        'lastModificationTime': json['lastModificationTime'] == null ? undefined : json['lastModificationTime'],
        'lastModifierUserId': json['lastModifierUserId'] == null ? undefined : json['lastModifierUserId'],
        'commentCount': json['commentCount'] == null ? undefined : json['commentCount'],
        'commentAttachmentsCount': json['commentAttachmentsCount'] == null ? undefined : json['commentAttachmentsCount'],
        'lastComment': json['lastComment'] == null ? undefined : json['lastComment'],
        'isAvailable': json['isAvailable'] == null ? undefined : json['isAvailable'],
        'origin': json['origin'] == null ? undefined : EntityOriginFromJSON(json['origin']),
        'possibleActions': json['possibleActions'] == null ? undefined : ((json['possibleActions'] as Array<any>).map(PossibleActionDtoFromJSON)),
        'creatorUser': json['creatorUser'] == null ? undefined : UserCatalogDtoFromJSON(json['creatorUser']),
        'lastModifierUser': json['lastModifierUser'] == null ? undefined : UserCatalogDtoFromJSON(json['lastModifierUser']),
        'editingUser': json['editingUser'] == null ? undefined : UserCatalogDtoFromJSON(json['editingUser']),
        'editingTime': json['editingTime'] == null ? undefined : json['editingTime'],
        'comments': json['comments'] == null ? undefined : ((json['comments'] as Array<any>).map(PtwCommentDtoFromJSON)),
        'attachments': json['attachments'] == null ? undefined : ((json['attachments'] as Array<any>).map(FileMetaInfoDtoFromJSON)),
        'isReferenced': json['isReferenced'] == null ? undefined : json['isReferenced'],
        'isReferencedBy': json['isReferencedBy'] == null ? undefined : ((json['isReferencedBy'] as Array<any>).map(ReferencingObjectDtoFromJSON)),
        'state': json['state'] == null ? undefined : StateOfUseFromJSON(json['state']),
        'name': json['name'],
        'iuid': json['iuid'] == null ? undefined : json['iuid'],
        'description': json['description'] == null ? undefined : json['description'],
        'protocols': json['protocols'] == null ? undefined : ((json['protocols'] as Array<any>).map(ProtocolDtoFromJSON)),
        'assignedUserIds': json['assignedUserIds'] == null ? undefined : json['assignedUserIds'],
        'assignedRoleIds': json['assignedRoleIds'] == null ? undefined : json['assignedRoleIds'],
        'assignedUsers': json['assignedUsers'] == null ? undefined : ((json['assignedUsers'] as Array<any>).map(UserCatalogDtoFromJSON)),
        'assignedRoles': json['assignedRoles'] == null ? undefined : ((json['assignedRoles'] as Array<any>).map(RoleCatalogDtoFromJSON)),
        'assignedRolesDisplayNames': json['assignedRolesDisplayNames'] == null ? undefined : json['assignedRolesDisplayNames'],
        'reviewRequired': json['reviewRequired'] == null ? undefined : json['reviewRequired'],
        'reviewUserIds': json['reviewUserIds'] == null ? undefined : json['reviewUserIds'],
        'reviewRoleIds': json['reviewRoleIds'] == null ? undefined : json['reviewRoleIds'],
        'reviewUsers': json['reviewUsers'] == null ? undefined : ((json['reviewUsers'] as Array<any>).map(UserCatalogDtoFromJSON)),
        'reviewRoles': json['reviewRoles'] == null ? undefined : ((json['reviewRoles'] as Array<any>).map(RoleCatalogDtoFromJSON)),
        'reviewRolesDisplayNames': json['reviewRolesDisplayNames'] == null ? undefined : json['reviewRolesDisplayNames'],
        'autoApprove': json['autoApprove'] == null ? undefined : json['autoApprove'],
        'targetSystemId': json['targetSystemId'] == null ? undefined : json['targetSystemId'],
        'targetSystem': json['targetSystem'] == null ? undefined : JobConfigurationDtoTargetSystemFromJSON(json['targetSystem']),
        'tasks': json['tasks'] == null ? undefined : ((json['tasks'] as Array<any>).map(TaskInJobDtoFromJSON)),
        'activeTaskInJobCount': json['activeTaskInJobCount'] == null ? undefined : json['activeTaskInJobCount'],
        'schedule': json['schedule'] == null ? undefined : JobScheduleDtoFromJSON(json['schedule']),
        '$type': json['$type'] == null ? undefined : json['$type'],
    };
}

export function JobConfigurationDtoToJSON(value?: Omit<JobConfigurationDto, 'creationTime'|'creatorUserId'|'lastModifierUserId'|'possibleActions'> | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return typeFirst({
        
        'id': value['id'],
        'lastModificationTime': value['lastModificationTime'],
        'commentCount': value['commentCount'],
        'commentAttachmentsCount': value['commentAttachmentsCount'],
        'lastComment': value['lastComment'],
        'isAvailable': value['isAvailable'],
        'origin': EntityOriginToJSON(value['origin']),
        'creatorUser': UserCatalogDtoToJSON(value['creatorUser']),
        'lastModifierUser': UserCatalogDtoToJSON(value['lastModifierUser']),
        'editingUser': UserCatalogDtoToJSON(value['editingUser']),
        'editingTime': value['editingTime'],
        'comments': value['comments'] == null ? undefined : ((value['comments'] as Array<any>).map(PtwCommentDtoToJSON)),
        'attachments': value['attachments'] == null ? undefined : ((value['attachments'] as Array<any>).map(FileMetaInfoDtoToJSON)),
        'isReferenced': value['isReferenced'],
        'isReferencedBy': value['isReferencedBy'] == null ? undefined : ((value['isReferencedBy'] as Array<any>).map(ReferencingObjectDtoToJSON)),
        'state': StateOfUseToJSON(value['state']),
        'name': value['name'],
        'iuid': value['iuid'],
        'description': value['description'],
        'protocols': value['protocols'] == null ? undefined : ((value['protocols'] as Array<any>).map(ProtocolDtoToJSON)),
        'assignedUserIds': value['assignedUserIds'],
        'assignedRoleIds': value['assignedRoleIds'],
        'assignedUsers': value['assignedUsers'] == null ? undefined : ((value['assignedUsers'] as Array<any>).map(UserCatalogDtoToJSON)),
        'assignedRoles': value['assignedRoles'] == null ? undefined : ((value['assignedRoles'] as Array<any>).map(RoleCatalogDtoToJSON)),
        'assignedRolesDisplayNames': value['assignedRolesDisplayNames'],
        'reviewRequired': value['reviewRequired'],
        'reviewUserIds': value['reviewUserIds'],
        'reviewRoleIds': value['reviewRoleIds'],
        'reviewUsers': value['reviewUsers'] == null ? undefined : ((value['reviewUsers'] as Array<any>).map(UserCatalogDtoToJSON)),
        'reviewRoles': value['reviewRoles'] == null ? undefined : ((value['reviewRoles'] as Array<any>).map(RoleCatalogDtoToJSON)),
        'reviewRolesDisplayNames': value['reviewRolesDisplayNames'],
        'autoApprove': value['autoApprove'],
        'targetSystemId': value['targetSystemId'],
        'targetSystem': JobConfigurationDtoTargetSystemToJSON(value['targetSystem']),
        'tasks': value['tasks'] == null ? undefined : ((value['tasks'] as Array<any>).map(TaskInJobDtoToJSON)),
        'activeTaskInJobCount': value['activeTaskInJobCount'],
        'schedule': JobScheduleDtoToJSON(value['schedule']),
        '$type': value['$type'],
    });
}

